import React from 'react';

const ConfigContext = React.createContext();

export const ConfigConsumer = ConfigContext.Consumer;

export const ConfigProvider = (props) => {

    const { config, children } = props;

    if (!children) {

        return null;

    }

    return (
        <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
    );

};

export const useConfig = () => {

    return React.useContext(ConfigContext); 

};
